import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-title',
  standalone: true,
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleLibComponent {
  text = input.required<string>();
  tag = input<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>('h1');
}
